import { lazy } from "react";
import { MODULE_IDS } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { app_navbar_routes } from "../../constants/app-navbar-routes";

//************************ Purchase Order Imports ***************************/
const PurchaseOrderTable = Loadable(
  lazy(() =>
    import("./PurchaseOrderTable").then(({ PurchaseOrderTable }) => ({
      default: PurchaseOrderTable,
    })),
  ),
);

const SinglePurchaseOrderForm = Loadable(
  lazy(() =>
    import("./SinglePurchaseOrderForm").then(({ SinglePurchaseOrderForm }) => ({
      default: SinglePurchaseOrderForm,
    })),
  ),
);
const PuchaseOrderApprovals = Loadable(
  lazy(() =>
    import("./PuchaseOrderApprovals").then(({ PuchaseOrderApprovals }) => ({
      default: PuchaseOrderApprovals,
    })),
  ),
);

//************************ Purchase Order Routes ***************************/
export const purchaseOrderRoutes = [
  {
    path: app_navbar_routes.app.requisitions_and_orders.purchase_order,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.PURCHASE_ORDER]}>
        <PurchaseOrderTable />
      </AuthorizedRoute>
    ),
  },
  {
    path: app_navbar_routes.app.approvals.purchase_order,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.PURCHASE_ORDER]}>
        <PuchaseOrderApprovals />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${app_navbar_routes.app.requisitions_and_orders.purchase_order}/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.PURCHASE_ORDER]}>
        <SinglePurchaseOrderForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${app_navbar_routes.app.requisitions_and_orders.purchase_order}/manage/:uuid`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.PURCHASE_ORDER]}>
        <SinglePurchaseOrderForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${app_navbar_routes.app.requisitions_and_orders.purchase_order}/duplicate/:uuid`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.PURCHASE_ORDER]}>
        <SinglePurchaseOrderForm isDuplicate={true} />
      </AuthorizedRoute>
    ),
  },
];
